import { Deferred, Head } from "@inertiajs/react";
import pageTitle from "../../utils/pageTitle.js";
import Breadcrumbs from "../../components/Breadcrumbs.jsx";
import ProductCard from "@/components/products/ProductCard.jsx";
import Filters from "~/pages/products/filters/Filters.jsx";
import { Skeleton } from "~/components/ui/skeleton.jsx";
import ProductsListPagination from "~/components/products/ProductsListPagination.jsx";
import ProductListHorizontalFilters from "~/components/products/ProductListHorizontalFilters.jsx";
import ActiveFilters from "~/components/products/ActiveFilters.jsx";
import { catalog_path } from "@/routes.js";
import { Heading } from "@/components/ui/heading.jsx";
import SearchBox from "~/components/products/SearchBox.jsx";
import pluralizeRu from "~/utils/pluralize.js";

const PRODUCTS_PER_PAGE = 40;

function Show(props) {
  const { products, taxon, filters, total, page } = props;

  const title = taxon.meta_title || taxon.name;
  const description = taxon.meta_description || taxon.meta_title || taxon.name;

  const currentPage = Number(page) || 1;
  const totalCount = Number(total) || 0;
  const shownFrom = totalCount === 0 ? 0 : (currentPage - 1) * PRODUCTS_PER_PAGE + 1;
  const shownTo = shownFrom === 0 ? 0 : shownFrom + products.length - 1;

  return (
    <>
      <Head title={pageTitle(title)}>
        {/* <title>{pageTitle(title)}</title> */}
        <meta
          name="description"
          content={description}
        />
      </Head>
      <div className="container mx-auto py-8 px-2 lg:px-0">
        <Breadcrumbs
          breadcrumbs={[
            { name: "Главная", href: "/" },
            { name: "Каталог", href: catalog_path() },
            { name: taxon.name, href: "" },
          ]}
        />
        <Heading as="h1" className="text-2xl lg:text-4xl">{title}</Heading>

        <div className="border-b border-gray-200 my-4 border-t py-4">
          <Deferred
            fallback={
              <div className="space-x-4 flex">
                <Skeleton className="h-[20px] w-[145px] rounded" />
                <Skeleton className="h-[20px] w-[120px] rounded" />
                <Skeleton className="h-[20px] w-[100px] rounded" />
              </div>
            }
            data={["filters"]}
          >
            <ProductListHorizontalFilters />
          </Deferred>
        </div>
        <div className="pb-4">
          <ActiveFilters />
        </div>
        <div className="flex">
          <div className="hidden _xl:block _xl:w-1/6">
            <Deferred fallback={<div>Загрузка...</div>} data={["filters"]}>
              <Filters filters={filters} />
            </Deferred>
          </div>

          <div className="w-full _lg:w-5/6 ">
            <div className="pb-4">
              <SearchBox size="xl" />
            </div>
            <div className="pb-4 text-sm text-gray-500">
              {totalCount > 0 && (
                <>
                  Показано {shownFrom}
                  {shownFrom !== shownTo ? `–${shownTo}` : ""} из {totalCount}{" "}
                  {pluralizeRu(totalCount, ["товар", "товара", "товаров"])}
                </>
              )}
            </div>
            <div className="grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-2 xl:gap-6 lg:gap-4">
              {products.map((product) => (
                <ProductCard
                  product={product}
                  key={`product-card-${product.id}`}
                  cover={!!taxon.product_card_type_cover}
                />
              ))}
            </div>
          </div>
        </div>
        <ProductsListPagination />
      </div>
    </>
  );
}

export default Show;
